// External
import { Component, OnInit } from '@angular/core';

// Internal

@Component({
    selector: 'drawer-main',
    template: `<ng-content></ng-content>`,
    host: {
        '[class.drawer-main]': 'true'
    } 
})

export class DrawerMainComponent implements OnInit {

    constructor() { }

    ngOnInit() {}

}
